export default __webpack_public_path__ + "static/media/hardhat.493970dd.png";